import React from 'react';
import { createFormatDate } from '../../utils';
import { Button } from '../Button';
import { ButtonGroup } from '../ButtonGroup';
import { getDecadeRange } from './DatePickerUtils';
export function DatePickerHeader(props) {
    const { prefix, suffix, date, locale, variant, setPeriod, allowYearMonthChange, } = props;
    const formatYearMonthTitle = createFormatDate({
        locale,
        month: 'long',
        year: 'numeric',
    });
    const formatMonthTitle = createFormatDate({
        locale,
        month: 'long',
    });
    const formatYearTitle = createFormatDate({
        locale,
        year: 'numeric',
    });
    const decadeRange = getDecadeRange(date);
    return (React.createElement("div", { className: "mollie-ui-date-picker-header" },
        prefix,
        React.createElement("div", { className: "mollie-ui-date-picker-title", "aria-hidden": "true" }, variant === 'year' ? (`${formatYearTitle(decadeRange[0])} - ${formatYearTitle(decadeRange[1])}`) : variant === 'month' ? (formatYearTitle(date)) : allowYearMonthChange ? (React.createElement(ButtonGroup, { size: "small", className: "mollie-ui-date-picker-month-year" },
            React.createElement(Button, { variant: "quaternary", onClick: () => setPeriod === null || setPeriod === void 0 ? void 0 : setPeriod('month') }, formatMonthTitle(date)),
            React.createElement(Button, { variant: "quaternary", onClick: () => setPeriod === null || setPeriod === void 0 ? void 0 : setPeriod('year') }, formatYearTitle(date)))) : (formatYearMonthTitle(date))),
        suffix));
}
//# sourceMappingURL=DatePickerHeader.js.map